import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HouseFlat } from '../../models/house-flat.model';
import { HouseFlatService } from '../../services/house-flat.service';

@Component({
  selector: 'app-house-flat-notification-modal',
  templateUrl: './house-flat-notification-modal.component.html',
  styleUrl: './house-flat-notification-modal.component.scss'
})
export class HouseFlatNotificationModalComponent {

  @Input() houseFlat?: HouseFlat;
  @Input() neighborhoodId: string = '';
  @Input() streetBuildingId: string = '';

  public formNotification: FormGroup;
  public submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    public houseFlatService: HouseFlatService,
  ) {
    this.formNotification = this.formBuilder.group({
      title: ['', Validators.required],
      subtitle: ['', Validators.required],
    });
  }

  get formControls() {
    return this.formNotification.controls;
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  async onSubmit() {
    this.submitted = true;
    if (this.formNotification.invalid) {
      return;
    }

    const flag = await this.houseFlatService.sendNotification(
      this.neighborhoodId,
      this.streetBuildingId,
      this.houseFlat!.houseFlatId,
      this.formNotification.value
    );

    if(flag) {
      this.activeModal.close();
    }
  }

}
